export class DatesRange {
  fromDate: Date;
  toDate: Date;

  public constructor(init?: Partial<DatesRange>) {
    Object.assign(this, init);
  }
}
